<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listEncargos"
        title-table="Encargos"
        module="encargosSettingsModule"
        sort-name="nome"
        :show-btn-add="verificarPermissao('ROLE_FINAN_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_FINAN_DELETAR')"
        @add="addNew"
        @edit="edit"
      />
      <FormEncargo 
        v-else 
        :encargo-data="encargo"
        @saved="cancelar" 
        @cancel="cancelar" 
      />
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol, BBadge } from 'bootstrap-vue'
import { verificarPermissao } from '@/auth/utils'
import FormEncargo from './forms/FormEncargo.vue'

export default {
  name: 'EncargoSetting',
  components: {
    BRow,
    BCol,
    BBadge,
    TableComponents,
    FormEncargo
  },
  computed: {
    ...mapState('encargosSettingsModule', {
      listEncargos: (state) => state.listEncargos,
      encargo: (state) => state.encargo
    })
  },
  data() {
    return {
      verificarPermissao,
      showForm: false,
      columns: [
        {
          label: this.$t('id'),
          field: 'id'
        },
        {
          label: 'Nome',
          field: 'nome'
        },
        {
          label: 'Tipo',
          field: 'tipoEncargo'
        },
        {
          label: 'Valor',
          field: 'valor'
        },
        {
          label: this.$t('Action'),
          field: 'action'
        }
      ]
    }
  },
  methods: {
    addNew() {
      this.$store.dispatch('encargosSettingsModule/reset')
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('encargosSettingsModule/prepareToEdit', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
      this.$store.dispatch('encargosSettingsModule/loadTable', { sort: 'nome', order: 'asc' })
    }
  }
}
</script>
